import React, {FC} from 'react';

import {Colors, RoundButton, Title, Skeleton} from '@optimaxdev/design-system';
import classNames from 'classnames';
import {useDispatch} from 'react-redux';
import Element from 'react-scroll/modules/components/Element';

import {setIsEditingOneStepMethod} from 'desktop/pages/checkout/store/reducers/paymentStep/oneStep/oneStep';

import {PrimerError} from '../primerError/primerError';

import s from './paymentWrapper.scss';

export type PropsType = {
    showSkeleton: boolean;
    children?: React.ReactNode;
    errorMessage?: string;
    isCreditCard?: boolean;
};

/**
 * One step checkout payment block
 */
export const PaymentWrapper: FC<PropsType> = ({
    children = null,
    errorMessage = '',
    isCreditCard = false,
    showSkeleton,
}) => {
    const dispatch = useDispatch();

    const handleOpenEditPayment = () => {
        dispatch(setIsEditingOneStepMethod(true));
    };

    return (
        <Element name="payment-title-one-step">
            <div className={s.container}>
                <div className={s.titleContainer}>
                    <Title color={Colors.blueCharcoal} level={2} lineHeight="40px">
                        Payment
                    </Title>

                    <RoundButton
                        className={s.editButton}
                        colorName="geyser"
                        onClick={handleOpenEditPayment}
                        size="small"
                        variant="painted"
                        isFull
                    >
                        Change Payment Method
                    </RoundButton>
                </div>
                {showSkeleton && <Skeleton className={s.skeleton} height={56} width={456} />}
                <div
                    aria-hidden={showSkeleton}
                    aria-label="payment-title-wrapper"
                    className={classNames({[s.hide]: showSkeleton})}
                >
                    {isCreditCard ? (
                        children
                    ) : (
                        <div
                            className={classNames(s.wrapper, {
                                [s.errorStyles]: Boolean(errorMessage),
                            })}
                        >
                            {children}
                        </div>
                    )}
                    <PrimerError primerError={errorMessage} />
                </div>
            </div>
        </Element>
    );
};
